/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Mk_Nav_R_TutorialInputs */

const en_mk_nav_r_tutorial = /** @type {(inputs: Mk_Nav_R_TutorialInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Full tutorial`)
};

const id_mk_nav_r_tutorial = /** @type {(inputs: Mk_Nav_R_TutorialInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Tutorial lengkap`)
};

/**
* | output |
* | --- |
* | "Full tutorial" |
*
* @param {Mk_Nav_R_TutorialInputs} inputs
* @param {{ locale?: "en" | "id" }} options
* @returns {LocalizedString}
*/
export const mk_nav_r_tutorial = /** @type {((inputs?: Mk_Nav_R_TutorialInputs, options?: { locale?: "en" | "id" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Mk_Nav_R_TutorialInputs, { locale?: "en" | "id" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "id") return id_mk_nav_r_tutorial(inputs)
	return en_mk_nav_r_tutorial(inputs)
});